import Fetch, { fetchConfig } from '@/hooks/fetch';
import paging, { pagingHookConfig } from '@/hooks/paging';
import { states } from '@/constants/lifecycle';
import actions from '../constants';

export default {
  useFetchCatalogueTemplates: ({ category }, readStatus, config = pagingHookConfig()) => paging.useDispatchByCategory(
    actions.FETCH_CATALOGUE_TEMPLATES,
    category,
    readStatus,
    config,
  ),
  useFetchCatalogueTemplateForDataset: ({
    category,
    code,
    datasetCode,
    templateReadStatus,
    intl,
  }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_CATALOGUE_TEMPLATE_FOR_DATASET,
    states.NONE,
    {
      category, datasetCode, intl, code,
    },
    fetchConfig([code], () => templateReadStatus === states.NONE && readStatus === states.SUCCESS),
  ),
};
